// react-imports
import React from "react";
import "./App.css";
// components
import Home from "./Components/Home";

function App() {
  return <Home />;
}

export default App;
